export default __webpack_public_path__ + "5803eeeb65f7f68930b0dfcfc14508a1.png";